import script from "./FooterFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterFooter.vue?vue&type=script&setup=true&lang=js"

import "./FooterFooter.vue?vue&type=style&index=0&id=05d1f572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d1f572"]])

export default __exports__